/* eslint-disable react/forbid-prop-types */
import React from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import SmallLoader from '../../../shared/components/SmallLoader';
import { monthWithDays } from '../helper';
import { setCurrencyFormat } from '../../../utils/helpers';

const MonthStats = ({ monthData, monthDataAll, month, filterBasedOnFilter, isPrevious, isLoading }) => {
  let mtdSales = 0;
  let avgDailySales = 0;
  let monthEstSales = 0;
  let unitPerOrder = 0;
  let aov = 0;

  const updatedMonthData = monthData.filter(item => filterBasedOnFilter(item));
  const { quantity } = updatedMonthData?.reduce((accum, item) => {
    const unitsDay = Number(Number(Number(accum?.quantity) + Number(item?.quantity)));
    return { quantity: unitsDay }
  }, { quantity: 0 });

  const updatedMonthDataAll = monthDataAll.filter(item => filterBasedOnFilter(item));
  const { orderCount, amount } = updatedMonthDataAll?.reduce((accum, item) => {
    const orderDay = Number(Number(Number(accum?.orderCount) + Number(item?.orderCount)));
   // const unitsDay = Number(Number(Number(accum?.quantity) + Number(item?.quantity)));
    const amountDay = Number(Number(Number(accum?.amount) + Number(item?.amount)));
    return { orderCount: orderDay, amount: amountDay }
  }, { orderCount: 0, amount: 0 });

  mtdSales = Number(amount).toFixed(2);

  const isCurrentMonth = moment().format("YYYY-MMM")
    === moment(`${month?.year}-${month?.month}`, "YYYY-MMM").format("YYYY-MMM")
  if (isCurrentMonth) {
    avgDailySales = Number(mtdSales / (moment().format('DD'))).toFixed(2);
  } else {
    avgDailySales = Number(mtdSales / (monthWithDays[month?.month] || 31)).toFixed(2);
  }

  monthEstSales = Number(avgDailySales *
    (moment(`${month?.year}-${month?.month}`, "YYYY-MMM").daysInMonth() || 31)).toFixed(2);

  aov = Number(mtdSales / orderCount).toFixed(2);

  unitPerOrder = Number(quantity / orderCount).toFixed(2);

  return (

    <Row>
      <Col xs="12">
        <Card className="pb-3">

          <CardTitle className="bold-text" tag="h5"><b>Month</b> {month?.year} {month?.month}</CardTitle>

          <CardBody style={{ background: isPrevious ? '#20b2aa' : '#008080' }}>
            {isLoading ? (
              <div
                style={{ minHeight: '150px' }}
                className="row align-items-center justify-content-center"
              >
                <SmallLoader loading={isLoading} />
              </div>) :
              <Row className="justify-content-center align-items-center">
                <Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      MTD Sales</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {setCurrencyFormat(mtdSales, true)}</CardText>
                  </Card>
                </Col>
                <Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      Avg Daily Sales</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {setCurrencyFormat(avgDailySales, true)}</CardText>
                  </Card>
                </Col>
                <Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      Month Est. Sales</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {setCurrencyFormat(monthEstSales, true)}</CardText>
                  </Card>
                </Col>
                <Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      Order Count</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {setCurrencyFormat(orderCount, false)}</CardText>
                  </Card>
                </Col><Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      Units Per Order</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {unitPerOrder}</CardText>
                  </Card>
                </Col><Col sm="6" md="3" lg="2">
                  <Card body>
                    <CardTitle className="bold-text" tag="h5" style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      AOV</CardTitle>
                    <CardText style={{ color: isPrevious ? '#39e600' : '#3366ff' }}>
                      {setCurrencyFormat(aov, true)}</CardText>
                  </Card>
                </Col>

              </Row>}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

MonthStats.propTypes = {
  monthData: PropTypes.array.isRequired,
  monthDataAll: PropTypes.array.isRequired,
  month: PropTypes.object.isRequired,
  filterBasedOnFilter: PropTypes.func.isRequired,
  isPrevious: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
};

MonthStats.defaultProps = {
  isPrevious: false
}

export default MonthStats;
